import React from 'react';
import classNames from 'classnames';

import { Organizer, DiscoveryEventsFromView } from '../types';

import { SocialWidget } from './SocialWidget';
import { OrganizerEvents } from './OrganizerEvents';
import { FollowOrganizer } from './FollowOrganizer';
import { ContactOrganizerButton } from './ContactOrganizerButton';

import './Main.scss';

interface MainProps {
    organizer: Organizer;
    events: DiscoveryEventsFromView;
}

export const Main: React.SFC<MainProps> = (props) => {
    const shouldRenderSocialContent =
        props.organizer.twitter || props.organizer.facebook;
    const eventSectionClasses = classNames('eds-g-cell', {
        'eds-g-cell-12-12 eds-g-cell-mn-8-12 eds-l-pad-right-4 eds-l-pad-bot-4': shouldRenderSocialContent,
        'eds-g-cell-12-12 eds-g-cell-mn-8-12 eds-g-offset-mn-2-12 eds-l-pad-bot-4': !shouldRenderSocialContent,
    });

    return (
        <main className="main">
            <div className="follow-organizer-container">
                <FollowOrganizer organizer={props.organizer} />
            </div>
            <section
                className={eventSectionClasses}
                style={{ position: 'relative' }}
            >
                <OrganizerEvents events={props.events} />
                <div className="contact-organizer-wrapper">
                    <ContactOrganizerButton />
                </div>
            </section>
            {shouldRenderSocialContent && (
                <section className="eds-g-cell eds-g-cell-12-12 eds-g-cell-mn-4-12">
                    <SocialWidget
                        facebook={props.organizer.facebook}
                        twitter={props.organizer.twitter}
                    />
                </section>
            )}
        </main>
    );
};
